const fallbackDefaultTranslations = {
  'announcement1': 'Delayed start of this match due to bad weather conditions',
  'announcement10': 'Interruption of this match due to floodlight failure',
  'announcement11': 'Interruption of this match due to a referee injury',
  'announcement12': 'Interruption of this match',
  'announcement13': 'New starting time for this match',
  'announcement14': 'Update of the starting time for this match',
  'announcement15': 'No transmission of this match at the moment',
  'announcement16': 'No transmission of this match - we will show the alternative event instead',
  'announcement17': 'No transmission of this match - the match has to be removed from the schedule',
  'announcement19': 'Next match on this channel',
  'announcement2': 'Delayed start of this match due to technical issues at the venue',
  'announcement20': 'We will switch to this match in a few minutes',
  'announcement21': 'We will switch to this match in 15 minutes',
  'announcement22': 'We will switch to this match in 10 minutes',
  'announcement23': 'We will switch to this match in 5 minutes',
  'announcement24': 'This match will be shown from the beginning until the end',
  'announcement25': 'Only the first-half of this match will be shown',
  'announcement26': 'Only the second-half of this match will be shown',
  'announcement27': 'Change of schedule - this match will be played next',
  'announcement28': 'Pending starting time due to bad weather conditions at the venue',
  'announcement3': 'Delayed start of this match due to a referee injury',
  'announcement4': 'Delayed start of this match due to a late team´s arrival to the venue',
  'announcement5': 'Interruption of this match due to bad weather conditions',
  'announcement6': 'Interruption of this match due to bad pitch conditions',
  'announcement7': 'Interruption of this match due to fan riots',
  'announcement8': 'Interruption of this match due to a quarrel between players',
  'announcement9': 'Interruption of this match due to a serious player injury',
  'crawlermatchbreak1': 'The match [E] will be displayed during the next break of the current live match',
  'crawlermatchbreak2': 'We’ll switch back to the match [E] as soon as the break is over',
  'liveevent1': 'No live data at the moment - we are working with high pressure on it.',
  'liveevent2': 'No scoreboard update at the moment - we are working with high pressure on it.',
  'liveevent3': 'No score update at the moment - we are working with high pressure on it.',
  'liveevent4': 'No clock update at the moment - we are working with high pressure on it.',
  'liveevent5': 'No statistics update at the moment - we are working with high pressure on it.',
  'liveevent6': 'The missing data will be updated as soon as possible.',
  'liveeventstreambreak1': 'Interruption of this match due to bad weather conditions.',
  'liveeventstreambreak10': 'Due to bad weather conditions, no matches can be played at the moment.',
  'liveeventstreambreak11': 'Due to bad pitch conditions, no matches can be played at the moment.',
  'liveeventstreambreak12': 'Coming up: [E]',
  'liveeventstreambreak13': 'Coming up: Second half of [E]',
  'liveeventstreambreak14': 'Coming up: Second period of [E]',
  'liveeventstreambreak15': 'Coming up: Third period of [E]',
  'liveeventstreambreak16': 'Coming up: Second quarter of [E]',
  'liveeventstreambreak17': 'Coming up: Third quarter of [E]',
  'liveeventstreambreak18': 'Coming up: Fourth quarter of [E]',
  'liveeventstreambreak19': 'Coming up: First set of [E]',
  'liveeventstreambreak2': 'Interruption of this match due to bad pitch conditions.',
  'liveeventstreambreak20': 'Coming up: Second set of [E]',
  'liveeventstreambreak21': 'Coming up: Third set of [E]',
  'liveeventstreambreak22': 'Coming up: Fourth set of [E]',
  'liveeventstreambreak23': 'Coming up: Fifth set of [E]',
  'liveeventstreambreak3': 'Interruption of this match due to fan riots.',
  'liveeventstreambreak4': 'Interruption of this match due to a quarrel between players.',
  'liveeventstreambreak5': 'Interruption of this match due to a serious players injury',
  'liveeventstreambreak6': 'Interruption of this matchd due to a stadium light breakdown.',
  'liveeventstreambreak7': 'Interruption of this match due to referee injury.',
  'liveeventstreambreak8': 'Interruption of this match.',
  'liveeventstreambreak9': "Interruptions of this match - we'll let you know as soon as the match continues.",
  'streambreak1': "No live signal at the moment - we'll switch back as soon as possible",
  'streambreak2': "No live signal at the moment - we'll switch to the alternative event",
  't_announcement_no_more_matches': 'No more scheduled matches today',
  't_announcement_tomorrow': 'Tomorrow',
  't_bs_call_to_action': 'Bet now on',
  't_bs_default_goal': 'Goal',
  't_bs_default_red_card': 'Red card',
  't_bs_default_start_of_first_half': '{X} starting now',
  't_bs_default_start_of_second_half': '{X} starting now',
  't_footer_att_strength': 'Att. Strength',
  't_footer_corner_kicks': 'Corner kicks',
  't_footer_first_half_score': '1st half score',
  't_footer_goals_conceded': 'goals conceded',
  't_footer_goals_scored': 'Goals Scored',
  't_footer_ground_form': 'Form',
  't_footer_last_matches': 'Last matches',
  't_footer_league_ranking': 'League ranking',
  't_footer_nationality': 'Nationality',
  't_footer_points_conceded': 'Points conceded',
  't_footer_points_per_match': 'Points per match',
  't_footer_points_scored': 'Points scored',
  't_footer_qrcode_place_bet': 'Want to place the bet?',
  't_footer_qrcode_scan_me': 'Scan me!',
  't_footer_score_action_prefix': 'ø {action}',
  't_footer_sets_per_match': 'Sets per match',
  't_general_aet': 'AET',
  't_general_ap': 'AP',
  't_general_badge_match_id': 'Match',
  't_general_d': 'D',
  't_general_ended': 'Ended',
  't_general_ht': 'HT',
  't_general_l': 'L',
  't_general_live': 'Live',
  't_general_match_day': 'Match day',
  't_general_ot': 'OT',
  't_general_otl': 'OTL',
  't_general_otw': 'OTW',
  't_general_p': 'P',
  't_general_q': 'Q',
  't_general_result_minus': '-',
  't_general_vs': 'vs',
  't_general_w': 'W',
  't_highlights_kickoff': 'Kickoff',
  't_highlights_match_of_the_day': 'Match of the day',
  't_highlights_starting_in': 'Starting in',
  't_live_goal': 'Goal',
  't_live_period_end': '{X}',
  't_live_red_card': 'Red card',
  't_live_set_is_drawing': '{X} is drawing to a close',
  't_live_set_starting_now': '{X} starting now',
  't_live_start_of_half': '{X} starting now',
  't_live_timeout': 'Timeout',
  't_opener_who_will_win': 'Who will win the game?',
  't_scoreboard_ad': 'AD',
  't_scoreboard_away': 'Away',
  't_scoreboard_break': 'Break',
  't_scoreboard_brk': 'Brk',
  't_scoreboard_home': 'Home',
  't_statistics_atp_ranking': 'ATP Ranking',
  't_statistics_attacking_strength': 'Attacking strength',
  't_statistics_clay': 'Clay',
  't_statistics_d': 'D',
  't_statistics_gf_ga': 'GF:GA',
  't_statistics_grass': 'Grass',
  't_statistics_halftime': 'Halftime',
  't_statistics_hardcourt': 'Hardcourt',
  't_statistics_indoor': 'Indoor',
  't_statistics_l': 'L',
  't_statistics_last_matches': 'Last matches',
  't_statistics_losses': 'Losses',
  't_statistics_match_start': 'Match Start',
  't_statistics_overall': 'Overall',
  't_statistics_performance': 'Performance',
  't_statistics_pld': 'PLD',
  't_statistics_pos': 'Pos',
  't_statistics_previous_meetings': 'Previous meetings',
  't_statistics_pts': 'PTS',
  't_statistics_team': 'Team',
  't_statistics_w': 'W',
  't_statistics_win_rate': 'Win Rate',
  't_statistics_wins': 'wins',
  't_statistics_wta_ranking': 'WTA Ranking',
  't_uof_odds_market_name_live_137_1': '1x2',
  't_uof_odds_market_name_live_137_10': 'Double chance',
  't_uof_odds_market_name_live_137_11': 'Draw no bet',
  't_uof_odds_market_name_live_137_113': 'OT - 1x2',
  't_uof_odds_market_name_live_137_114': 'OT - which team wins the rest',
  't_uof_odds_market_name_live_137_115': 'OT - {!goalnr} goal',
  't_uof_odds_market_name_live_137_116': 'OT - total',
  't_uof_odds_market_name_live_137_123': 'Penalty shootout - winner',
  't_uof_odds_market_name_live_137_14': 'Handicap ({hcp})',
  't_uof_odds_market_name_live_137_16': 'Handicap',
  't_uof_odds_market_name_live_137_18': 'Total',
  't_uof_odds_market_name_live_137_23': '{$competitor1} exact goals',
  't_uof_odds_market_name_live_137_24': '{$competitor2} exact goals',
  't_uof_odds_market_name_live_137_60': '1st half - 1x2',
  't_uof_odds_market_name_live_137_61': '1st half - which team wins the rest',
  't_uof_odds_market_name_live_137_66': '1st half - handicap',
  't_uof_odds_market_name_live_137_68': '1st half - total',
  't_uof_odds_market_name_live_137_7': 'Rest of the match',
  't_uof_odds_market_name_live_137_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_1_1': '1x2',
  't_uof_odds_market_name_live_1_10': 'Double chance',
  't_uof_odds_market_name_live_1_11': 'Draw no bet',
  't_uof_odds_market_name_live_1_113': 'OT - 1x2',
  't_uof_odds_market_name_live_1_114': 'OT - which team wins the rest',
  't_uof_odds_market_name_live_1_115': 'OT - {!goalnr} goal',
  't_uof_odds_market_name_live_1_116': 'OT - total',
  't_uof_odds_market_name_live_1_123': 'Penalty shootout - winner',
  't_uof_odds_market_name_live_1_14': 'Handicap ({hcp})',
  't_uof_odds_market_name_live_1_16': 'Handicap',
  't_uof_odds_market_name_live_1_18': 'Total',
  't_uof_odds_market_name_live_1_23': '{$competitor1} exact goals',
  't_uof_odds_market_name_live_1_24': '{$competitor2} exact goals',
  't_uof_odds_market_name_live_1_60': '1st half - 1x2',
  't_uof_odds_market_name_live_1_61': '1st half - which team wins the rest',
  't_uof_odds_market_name_live_1_62': '1st half - {!goalnr} goal',
  't_uof_odds_market_name_live_1_66': '1st half - handicap',
  't_uof_odds_market_name_live_1_68': '1st half - total',
  't_uof_odds_market_name_live_1_7': 'Rest of the match',
  't_uof_odds_market_name_live_1_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_20_186': '1 2',
  't_uof_odds_market_name_live_20_199': 'Correct score',
  't_uof_odds_market_name_live_20_221': '{!scorenr} score (incl. overtime)',
  't_uof_odds_market_name_live_20_237': 'Point handicap',
  't_uof_odds_market_name_live_20_238': 'Total points',
  't_uof_odds_market_name_live_20_241': 'Exact games',
  't_uof_odds_market_name_live_20_245': 'Win {pSuffix} Set',
  't_uof_odds_market_name_live_20_246': 'Asian HC Set {period}.',
  't_uof_odds_market_name_live_20_247': 'Total Games In Set $x.',
  't_uof_odds_market_name_live_20_300': 'Race to {pointnr} points',
  't_uof_odds_market_name_live_23_186': '1 2',
  't_uof_odds_market_name_live_23_199': 'Correct score',
  't_uof_odds_market_name_live_23_202': 'Winner Set $x',
  't_uof_odds_market_name_live_23_221': '{!scorenr} score (incl. overtime)',
  't_uof_odds_market_name_live_23_237': 'Point handicap',
  't_uof_odds_market_name_live_23_238': 'Total points',
  't_uof_odds_market_name_live_23_309': 'POINTS HANDICAP FOR SET $x',
  't_uof_odds_market_name_live_23_310': 'Total Set $x',
  't_uof_odds_market_name_live_23_563': 'Race to {pointnr} points',
  't_uof_odds_market_name_live_23_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_29_1': '1x2',
  't_uof_odds_market_name_live_29_16': 'Handicap',
  't_uof_odds_market_name_live_29_18': 'Total',
  't_uof_odds_market_name_live_29_23': '{$competitor1} exact goals',
  't_uof_odds_market_name_live_29_24': '{$competitor2} exact goals',
  't_uof_odds_market_name_live_29_60': '1st half - 1x2',
  't_uof_odds_market_name_live_29_61': '1st half - which team wins the rest',
  't_uof_odds_market_name_live_29_66': '1st half - handicap',
  't_uof_odds_market_name_live_29_68': '1st half - total',
  't_uof_odds_market_name_live_29_7': 'Rest of the match',
  't_uof_odds_market_name_live_29_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_2_219': '1 2 (incl. OT)',
  't_uof_odds_market_name_live_2_223': 'Asian Handicap Incl. OT',
  't_uof_odds_market_name_live_2_225': 'Total Incl. OT',
  't_uof_odds_market_name_live_2_23': '{$competitor1} exact goals',
  't_uof_odds_market_name_live_2_236': 'Total Q$x',
  't_uof_odds_market_name_live_2_24': '{$competitor2} exact goals',
  't_uof_odds_market_name_live_2_291': '{!pointnr} point (incl. OT)',
  't_uof_odds_market_name_live_2_302': 'Win Q$x',
  't_uof_odds_market_name_live_2_303': 'Asian Handicap Q$x',
  't_uof_odds_market_name_live_2_563': 'Race to {pointnr} points',
  't_uof_odds_market_name_live_2_64': '1st half - draw no bet',
  't_uof_odds_market_name_live_2_66': '1st half - handicap',
  't_uof_odds_market_name_live_2_68': '1st half - total',
  't_uof_odds_market_name_live_2_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_34_186': '1 2',
  't_uof_odds_market_name_live_34_199': 'Correct score',
  't_uof_odds_market_name_live_34_202': '{!setnr} set - winner',
  't_uof_odds_market_name_live_34_221': '{!scorenr} score (incl. overtime)',
  't_uof_odds_market_name_live_34_237': 'Point handicap',
  't_uof_odds_market_name_live_34_238': 'Total points',
  't_uof_odds_market_name_live_34_300': 'Race to {pointnr} points',
  't_uof_odds_market_name_live_34_309': '{!setnr} set - point handicap',
  't_uof_odds_market_name_live_34_310': '{!setnr} set - total points',
  't_uof_odds_market_name_live_34_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_4_1': '1x2',
  't_uof_odds_market_name_live_4_10': 'Double chance',
  't_uof_odds_market_name_live_4_11': 'Draw no bet',
  't_uof_odds_market_name_live_4_116': 'OT - total',
  't_uof_odds_market_name_live_4_14': 'Handicap ({hcp})',
  't_uof_odds_market_name_live_4_18': 'Total',
  't_uof_odds_market_name_live_4_23': '{$competitor1} exact goals',
  't_uof_odds_market_name_live_4_24': '{$competitor2} exact goals',
  't_uof_odds_market_name_live_4_443': 'Win {pSuffix} Period',
  't_uof_odds_market_name_live_4_446': 'TOTAL {pSuffix} PERIOD',
  't_uof_odds_market_name_live_4_458': '{!periodnr} period - which team wins the rest',
  't_uof_odds_market_name_live_4_464': 'OT - draw no bet',
  't_uof_odds_market_name_live_4_7': 'Rest of the match',
  't_uof_odds_market_name_live_4_8': '{!goalnr} goal',
  't_uof_odds_market_name_live_5_1': '1x2',
  't_uof_odds_market_name_live_5_186': '1 2',
  't_uof_odds_market_name_live_5_189': 'Total games',
  't_uof_odds_market_name_live_5_196': 'Exact sets',
  't_uof_odds_market_name_live_5_199': 'Correct score',
  't_uof_odds_market_name_live_5_202': '{!setnr} set - winner',
  't_uof_odds_market_name_live_5_203': '{!setnr} set - game handicap',
  't_uof_odds_market_name_live_5_204': 'Total Games In Set $x.',
  't_uof_odds_market_name_live_5_206': '{!setnr} set - will there be a tiebreak',
  't_uof_odds_market_name_live_5_209': '{!setnr} set - {!gamenrX} and {!gamenrY} game winner',
  't_uof_odds_market_name_live_5_210': 'WINNER OF GAME $x',
  't_uof_odds_market_name_live_6_1': '1x2',
  't_uof_odds_market_name_live_6_116': 'Total Incl. OT',
  't_uof_odds_market_name_live_6_117': 'Asian Handicap Incl. OT',
  't_uof_odds_market_name_live_6_14': 'Handicap ({hcp})',
  't_uof_odds_market_name_live_6_16': 'Handicap',
  't_uof_odds_market_name_live_6_18': 'Total',
  't_uof_odds_market_name_live_6_23': '{$competitor1} exact goals',
  't_uof_odds_market_name_live_6_24': '{$competitor2} exact goals',
  't_uof_odds_market_name_live_6_404': '{!goalnr} goal (incl. overtime)',
  't_uof_odds_market_name_live_6_563': 'Race to {pointnr} points',
  't_uof_odds_market_name_live_6_60': '1st half - 1x2',
  't_uof_odds_market_name_live_6_65': '1st half - handicap {hcp}',
  't_uof_odds_market_name_live_6_66': '1st half - handicap',
  't_uof_odds_market_name_live_6_68': '1st half - total',
  't_uof_odds_market_name_live_6_8': '{!goalnr} goal',
  't_uof_odds_market_name_pre_1_1': '1x2',
  't_uof_odds_market_name_pre_1_14': 'Handicap ({hcp})',
  't_uof_odds_market_name_pre_23_1': '1x2',
  't_uof_odds_market_name_pre_29_1': '1x2',
  't_uof_odds_market_name_pre_2_1': '1x2',
  't_uof_odds_market_name_pre_2_223': 'Asian Handicap Incl. OT',
  't_uof_odds_market_name_pre_34_1': '1x2',
  't_uof_odds_market_name_pre_4_1': '1x2',
  't_uof_odds_market_name_pre_5_1': '1x2',
  't_uof_odds_market_name_pre_6_1': '1x2',
  't_uof_odds_market_name_pre_6_14': 'Handicap ({hcp})',
};

export default fallbackDefaultTranslations;
